'use client';
import React from 'react';
import { Spacer } from '../../../parts/Spacer';
import { FormValidationMessage } from '../FormValidationMessage';

export const FormTextArea: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    validationMessage?: string;
    placeholder?: string;
  }
> = ({ validationMessage, ...attr }) => {
  const textAreaRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (textAreaRef && textAreaRef.current) {
      textAreaRef.current.innerText = attr?.defaultValue
        ? (attr.defaultValue as string)
        : '';
    }
  }, [attr?.defaultValue]);

  return (
    <div>
      <div className="tw-relative">
        <div
          className={
            validationMessage
              ? 'tw-absolute tw-inset-0 tw-rounded-4 tw-bg-caution-lv1 tw-opacity-20'
              : 'tw-absolute tw-inset-0 tw-rounded-4 tw-bg-base-lv1'
          }
        />
        <div
          {...attr}
          className="tw-relative tw-min-h-[6rem] tw-resize-y tw-overflow-hidden tw-rounded-4 tw-border-[2px] tw-border-main-60 tw-p-[0.5rem] tw-text-base1 tw-leading-[1.6] tw-text-main-100 empty:before:tw-text-base2 empty:before:tw-leading-[1.6] empty:before:tw-text-main-60 empty:before:tw-content-[attr(placeholder)]"
          role="textbox"
          ref={textAreaRef}
          aria-multiline={true}
          contentEditable={true}
        />
      </div>
      {validationMessage && (
        <>
          <Spacer level={0.5} />
          <FormValidationMessage message={validationMessage} />
        </>
      )}
    </div>
  );
};

// const TextArea = styled.div<CustomProps>`
//   ${typo.Standard};
//   background-color: ${({ theme }) => theme.background.primary};
//   border-radius: 0.2rem;
//   border: 2px solid
//     ${({ theme, isError = false }) =>
//       isError ? theme.keyColor.error : theme.foreground.tertiary};
//   box-shadow: none;
//   color: ${({ theme }) => theme.foreground.primary};
//   display: block;
//   width: 100%;
//   overflow: hidden;
//   resize: vertical;
//   min-height: 6rem;
//   line-height: 1.6;
//   padding: 0.5rem;
//   position: relative;

//   &[contenteditable] {
//     &:empty::before {
//       ${typo.Standard};
//       content: ${({ placeholder }) => (placeholder ? `"${placeholder}"` : '')};
//       color: ${({ theme }) => theme.foreground.tertiary};
//       display: block;
//       line-height: 1.6;
//     }
//   }
// `;
